import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const sessionUuid = localStorage.getItem('sessionUuid')
    if (sessionUuid && config.headers) {
      // 直接使用 session_uuid 作为 Authorization 值
      config.headers.Authorization = sessionUuid
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('sessionUuid')
      localStorage.removeItem('role')
      localStorage.removeItem('username')
      localStorage.removeItem('uuid')
      localStorage.removeItem('describe')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// API functions

export const login = async (data) => {
  // 登录接口不需要 Authorization 头
  const response = await axiosInstance.post('/api/auth/login', data, {
    transformRequest: [(data, headers) => {
      // 清除 Authorization 头
      delete headers.Authorization
      return JSON.stringify(data)
    }]
  })

  // 后端直接返回 JSON 对象：{ code, message, data }
  if (response.data.code !== 'OK') {
    throw new Error(response.data.message || 'Login failed')
  }

  return response.data.data
}

export const getUserInfo = async () => {
  const response = await axiosInstance.get('/api/user/get_info')

  // 后端直接返回 data 对象：{ username, role, upload, download, total, uuid, describe }
  return response.data.data
}

export const verifyToken = async () => {
  const response = await axiosInstance.get('/api/tokenverify')

  // tokenverify 接口也直接返回数据，格式：{ valid, message, username } 或类似
  return response.data
}

export const setAuthToken = (token) => {
  localStorage.setItem('sessionUuid', token)
}

export const clearAuth = () => {
  localStorage.removeItem('sessionUuid')
  localStorage.removeItem('role')
  localStorage.removeItem('username')
  localStorage.removeItem('uuid')
  localStorage.removeItem('describe')
  localStorage.removeItem('upload')
  localStorage.removeItem('download')
  localStorage.removeItem('total')
}

export default axiosInstance
